import * as React from 'react';

import {RouteComponentProps} from 'react-router';
import LessonApi from '../modules/lessons/api/LessonApi';
import Lesson from '../modules/lessons/domain/aggregates/lesson/Lesson';
import Page from './Page';
import LessonResultApi from '../modules/lessons/api/LessonResultApi';
import ExerciseApi from '../modules/lessons/api/ExerciseApi';
import { Button, Table, Icon, Grid, Header } from 'semantic-ui-react';
import Exercise from '../modules/lessons/domain/aggregates/exercise/Exercise';
import Course from '../modules/lessons/domain/aggregates/course/Course';
import CourseApi from '../modules/lessons/api/CourseApi';
import LessonResult from '../modules/lessons/domain/aggregates/lessonResult/LessonResult';
import Registry from '../global/Registry';
import ReviewReminder from './components/lesson/ReviewReminder';
import {Link} from 'react-router-dom';

interface Props {
	id?: string;
}

interface State {
	courses: Course[];
	lessons: Lesson[];
	exercisesToReview: Exercise[];
	lessonResults: LessonResult[];
	course?: Course;
}

export default class HomePage extends Page<RouteComponentProps<Props>, State> {

	public constructor (props: RouteComponentProps<Props>) {
		super(props);

		this.state = { lessons: [], courses: [], exercisesToReview: [], lessonResults: []};
	}

	async componentWillMount () {
		const [courses, lessons, exercisesToReview, lessonResults] = await Promise.all([
			CourseApi.getInstance().getAll(),
			LessonApi.getInstance().getAll(),
			ExerciseApi.getInstance().getAllToRepeatByUserId(Registry.getInstance().me.getId()),
			LessonResultApi.getInstance().getAllByUserId(Registry.getInstance().me.getId())
		]);

		const course = Registry.getInstance().courseRepository.getOneOrUndefinedByIdValue(this.props.match.params.id);

		this.setState({courses, lessons, exercisesToReview, lessonResults, course});
	}

	async componentWillReceiveProps (props: RouteComponentProps<Props>) {
		const course = Registry.getInstance().courseRepository.getOneOrUndefinedByIdValue(props.match.params.id);

		this.setState({course});
	}

	protected isLoading (): any {
		return this.state.courses.length === 0;
	}

	protected renderTitle (): string {
		return 'Brain Brooder - Digital Math & Science Education';
	}

	protected renderDescription (): string {
		return 'Learn Math and Science deeply, by taking small but dense lessons that are followed by intelligently repeated exercises, such that you never forget.';
	}

	protected renderContent () {
		const courses = this.state.courses;

		const privateCourses = courses.filter(course => course.getVisibility().isPrivate());

		const path = this.props.match.path;

		return (
			<div className='lesson home'>
				<div style={{textAlign: 'center'}}>
					<Header className={'main'} inverted as='h1' content='Brain Brooder' subheader='Learn and never forget anything due to intelligent repetition' style={{margin: '36px'}} />

					<ReviewReminder />

					<div className={'tabs2'} style={{marginTop: '48px'}}>

						<input id='tab1' type='radio' name='tabs' checked={path === '/'} readOnly />
						<label id='label1' onClick={() => Page.navigate('/')}><Icon name={'users'} /> <Link style={{color: 'inherit'}} to={'/'}>Public courses</Link></label>

						<input id='tab2' type='radio' name='tabs' readOnly checked={path === '/my-courses'} />
						<label id='label2' onClick={() => Page.navigate('/my-courses')}><Icon name={'user'} /> <Link style={{color: 'inherit'}} to={'/my-courses'}>My courses</Link></label>

						{/*<input id='tab3' type='radio' name='tabs' readOnly checked={path === '/businesses'} />*/}
						{/*<label id='label3' onClick={() => Page.navigate('/businesses')}><Icon name={'building'} /> <Link style={{color: 'inherit'}} to={'/businesses'}>Businesses</Link></label>*/}

						{/*<input id='tab4' type='radio' name='tabs' readOnly checked={path === '/schools'} />*/}
						{/*<label id='label4' onClick={() => Page.navigate('/schools')}><Icon name={'university'} /> <Link style={{color: 'inherit'}} to={'/schools'}>Schools</Link></label>*/}

						<section id='content1'>

							<h2 style={{marginTop: '24px'}}>
								<img src='https://elon.io/static/images/arrow-right-bottom.png' style={{ transform: 'rotateY(180deg)', paddingTop: '20px', display: 'inline-block'}} />
								<span style={{display: 'inline-block', verticalAlign: 'top', lineHeight: '40px', padding: '0 10px'}}>Pick a course to start learning</span>
								<img src='https://elon.io/static/images/arrow-right-bottom.png' />
							</h2>

							<PublicCourses />
						</section>

						<section id='content2'>
							{privateCourses.length > 0 ? (
								<div>
									<CoursesTable title='Courses' courses={privateCourses} />

									<Button inverted color={'grey'} fluid onClick={() => Page.navigate('/course/new')} style={{marginTop: '36px'}}><Icon name={'plus'} />  Create a new course</Button>
								</div>
							) : (
								<div>
									<div style={{margin: '48px 0'}}>
										<h2>You haven't created any courses yet.</h2>
									</div>
									<p><Button inverted size={'big'} color={'green'} onClick={() => Page.navigate('/course/new')}><Icon name={'plus'} />  Create your first course</Button></p>
								</div>
							)}
						</section>

						<section id='content3'>
							<Header inverted as={'h2'} style={{margin: '24px 0 36px'}} content={'Brain Brooder for Businesses'} />

							<p style={{marginBottom: '36px'}}>
								<strong style={{color: '#F2711C'}}>Train your employees for lifelong mastery</strong><br />
								Brain Brooder uses a spaced repetition system that efficiently ensures that your employees will never forget what they have learned.
							</p>

							<p style={{marginBottom: '36px'}}>
								<strong style={{color: '#F2711C'}}>Get up to speed in 10 minutes</strong><br />
								Creating your first lesson and inviting your employees should take you no more than ten minutes.
							</p>

							<p style={{marginBottom: '36px'}}>
								<strong style={{color: '#F2711C'}}>Help to support free education for all</strong><br />
								By using Brain Brooder, you support people all around the world to receive free high-quality education.
							</p>

							<p style={{marginBottom: '36px'}}>
								<strong style={{color: '#F2711C'}}>Try it for free</strong><br />
								Make a business account now and try Brain Brooder <strong>30 days for free</strong>, without entering any payment details.
							</p>

							<p><Link to={'/businesses/sign-up'}><Button inverted size={'big'} color={'blue'}><Icon name={'plus'} />  Create a business account</Button></Link></p>
						</section>

						{/*<section id='content4'>*/}

						{/*</section>*/}
					</div>
				</div>
			</div>
		);
	}
}

const PublicCourses: React.SFC<{}> = () => {

	return (
		<div>
			<Grid>
				<Grid.Row columns={2}>
					<Grid.Column>
						<div className='course' style={{padding: '12px', border: '1px solid #eeeeee', borderRadius: '12px' }} onClick={() => Page.navigate('/course/9/biology')}>
							<div style={{height: '250px'}}>
								<img className='inverted' src='https://upload.wikimedia.org/wikipedia/commons/5/53/Baer_embryos.png' style={{ width: '100%' }} />
							</div>
							<h2 style={{textAlign: 'center'}}><a href='/course/9/biology'>Biology</a></h2>
						</div>
					</Grid.Column>
					<Grid.Column>
						<div className='course' style={{padding: '12px', border: '1px solid #eeeeee', borderRadius: '12px'}} onClick={() => Page.navigate('/course/3/geography')}>
							<div style={{height: '250px'}}>
								{/*<img src='https://brainbrooder.com/api/image?top=10&url=https://upload.wikimedia.org/wikipedia/commons/7/7a/Admirals_Hyland%2C_McCain%2C_Moorer%2C_Holmes_1968.jpg' style={{ width: '100%' }} />*/}
								<img className={'inverted'} src='https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Simple_world_map.svg/800px-Simple_world_map.svg.png' style={{ width: '100%', paddingTop: '40px' }} />
							</div>
							<h2 style={{textAlign: 'center'}}><a href='/course/3/geography'>Geography</a></h2>
						</div>
					</Grid.Column>
				</Grid.Row>
				<Grid.Row columns={2}>
					<Grid.Column>
						<div className='course' style={{padding: '12px', border: '1px solid #eeeeee', borderRadius: '12px' }} onClick={() => Page.navigate('/course/19/greek-alphabet')}>
							<div style={{height: '250px'}}>
								<img className='inverted' src={'https://brainbrooder.com/api/image?url=' + encodeURIComponent('https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Alfabeto_griego_Times_New_Roman.svg/800px-Alfabeto_griego_Times_New_Roman.svg.png') + '&top=12'} style={{ width: '100%', paddingTop: '48px' }} />
							</div>
							<h2 style={{textAlign: 'center'}}><a href='/course/19/greek-alphabet'>Greek alphabet</a></h2>
						</div>
					</Grid.Column>
					<Grid.Column>
						<div className='course' style={{padding: '12px', border: '1px solid #eeeeee', borderRadius: '12px', textAlign: 'center' }} onClick={() => Page.navigate('/course/1/set-theory')}>
							<div style={{height: '250px'}}>
								<img className='grayscale' src={'https://upload.wikimedia.org/wikipedia/commons/5/5a/Venn0010.svg'} style={{ width: '100%', margin: '24px 0 0 10px' }} />
							</div>
							<h2 style={{textAlign: 'center'}}><a href='/course/1/set-theory'>Set Theory</a></h2>
						</div>
					</Grid.Column>
				</Grid.Row>
				{/*<Grid.Row columns={2}>*/}
					{/*<Grid.Column>*/}
						{/*<div className='course' style={{padding: '12px', border: '1px solid #eeeeee', borderRadius: '12px' }} onClick={() => Page.navigate('/course/21/turkish')}>*/}
							{/*<div style={{height: '250px'}}>*/}
								{/*<img className='grayscale' src={'https://upload.wikimedia.org/wikipedia/commons/0/08/Harf_Devrimi%2C_M._Kemal_Atat%C3%BCrk.jpg'} style={{ width: '100%', marginTop: '8px' }} />*/}
							{/*</div>*/}
							{/*<h2 style={{textAlign: 'center'}}><a href='/course/21/turkish'>Turkish</a></h2>*/}
						{/*</div>*/}
					{/*</Grid.Column>*/}
				{/*</Grid.Row>*/}
			</Grid>

			<div style={{margin: '64px 0'}}>
				<h3 style={{color: '#F2711C', fontSize: '1.2em'}}>Support us through Patreon to help us add more courses.</h3>
				<p>Once we reach $316 in monthly support,<br />we'll add a course on <strong>Psychology</strong>.</p>
				<a href={'https://www.patreon.com/bePatron?u=906767'} target={'_blank'}><Button type={'button'} color={'green'} size={'big'}>Support us now!</Button></a>
			</div>
		</div>
	);
};

const CoursesTable: React.SFC<{title: string, courses: Course[]}> = ({title, courses}) => {

	return (
		<Table inverted selectable unstackable>
			<Table.Header>
				<Table.Row>
					<Table.HeaderCell>{title}</Table.HeaderCell>
				</Table.Row>
			</Table.Header>
			<Table.Body>
				{courses.sort((a, b) => a.getName().localeCompare(b.getName())).map((course, key) => <Table.Row key={key} onClick={() => Page.navigate(course.getSlug())}><Table.Cell><a onClick={(event) => event.preventDefault()} style={{color: 'inherit'}} href={course.getSlug()}>{course.getName()}</a></Table.Cell></Table.Row>)}
			</Table.Body>
		</Table>
	);
};


// WEBPACK FOOTER //
// ./code/project/pages/HomePage.tsx